export interface IManualInvoiceLineItemTax {
    id: number,
    lineItemTypeDesc: string,
    lineItemType: number,
    taxPercent: number
}